<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['d-flex', getSelectedDEV && 'dev-selected-component']"
    :key="generateId(schema.model)"
  >
    <i4pro-icon-popover
      v-if="schema.attributesInfo"
      :class="[schema.attributesInfo.right ? 'ml-1 order-2' : 'mr-1']"
      :schema="schema"
      :model="model"
    ></i4pro-icon-popover>

    <v-layout class="mx-0">
      <v-text-field
        ref="v_text_field"
        v-bind="schema.attributesTextField"
        :disabled="schema.readonly"
        v-model="itemText"
        :name="schema.model"
        :id="generateId(schema.model)"
        :rules="rules"
        @click:append="ToogleShowCard"
        @click:clear="clearHandle"
        @blur="onBlur"
        @change="onChangeHandle"
        @focus="onFocus"
        @input="onInput"
        class="i4pro-text-field-search--input"
      >
        <template v-slot:label>
          {{ schema.attributesTextField.label }}
          <span v-if="schema.rules.includes('required')" class="red--text">*</span>
        </template>
      </v-text-field>

      <v-dialog v-model="showDialog" v-bind="schema.attributesDialog">
        <v-card>
          <v-toolbar dark :color="schema.attributesDialog.cardTolbarColor">
            <v-toolbar-title>{{ schema.attributesDialog.cardTolbarTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="ToogleShowCard">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="p-0">
            <i4proTable
              :items="items"
              :schema="schema.attributesTable"
              :headers="schema.attributesTable.headers"
              :lookupwindow="true"
              @select-item="selectItem"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import i4proTextField from '@/components/inputs/i4pro-text-field';
import devComponentMixin from '@/mixins/dev-component-mixin';
import pageServices from '@/services/page';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import componentMixin from '@/mixins/component-mixin';

export default {
  mixins: [i4proTextField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  components: {
    i4proTable: () => import('@/components/tables/i4pro-table'),
    i4proIconPopover: () => import('@/components/icons/i4pro-icon-popover')
  },

  data() {
    return {
      showDialog: false,
      init: true,
      items: [],
      itemText: '',
      itemModalSelected: false,
      required: value => {
        return !!this.itemModalSelected || `Este campo é obrigatório`;
      }
    };
  },

  watch: {
    model: {
      handler(newValue, oldValue) {
        // a model nao foi alterada
        if (oldValue && newValue[this.schema.model] !== oldValue[this.schema.model] && !!newValue[this.schema.model] === false) {
          this.model[this.schema.model] = '';
          this.itemText = '';
          this.itemModalSelected = false;
          this.$refs.v_text_field.$emit('change');
          this.$refs.nextSibling.$el.focus();
        }

        this.getLookupText();
      },
      immediate: true
    }
  },
  
  methods: {
    clearHandle() {
      this.$nextTick(() => {
        this.model[this.schema.model] = '';
        this.itemText = '';
        this.itemModalSelected = false;
        this.$refs.v_text_field.$emit('change');
      });
    },

    async selectItem(item) {
      this.$nextTick(() => {
        this.model[this.schema.model] = item[this.schema.searchParams.value];
        this.itemText = item[this.schema.searchParams.text];
        this.showDialog = false;
        this.itemModalSelected = true;
        this.$refs.v_text_field.$emit('change');
        this.$refs?.nextSibling?.focus();
      });
    },

    async getLookupText() {
      if (this.init && this.model) {
        if (this.model[this.schema.model]) {
          const model = { ...JSON.parse(JSON.stringify(this.model)), ...{ id: this.model[this.schema.model] } };
          const lookupWindow = {
            procedure: this.schema.searchParams.procedure,
            component: this.schema.searchParams.component,
            requestApi: this.schema.searchParams.requestApi,
            model,
            page: this.formOptions.page
          };

          const { data } = await pageServices.lookupWindow(lookupWindow);

          this.itemText = data.values[0][this.schema.searchParams.text];
          this.itemModalSelected = true;
        }

        this.init = false;
      }
    },

    async ToogleShowCard() {
      let show = !this.showDialog;

      if (show) {
        const model = { ...JSON.parse(JSON.stringify(this.model)), ...{ like: this.itemText } };
        const lookupWindow = {
          procedure: this.schema.searchParams.procedure,
          component: this.schema.searchParams.component,
          requestApi: this.schema.searchParams.requestApi,
          model,
          page: this.formOptions.page
        };

        const { data } = await pageServices.lookupWindow(lookupWindow);

        if (data.isValid) this.items = data.values;
      } else this.items = [];

      this.showDialog = show;
    },

    async onChangeHandle() {
      await this.changeEvents();
    }
  }
};
</script>